<!--
  name : 김혜진
  desc : 요금
  date : 2020-11-25
-->
<template>
  <v-container class="con_mpw">
    <v-row no-gutters class="scrollH100">
      <v-col col="12"  v-if="getOrgname()">
        <!--2 사용자가 기업일때-->
        <company ref="company" ></company>
      </v-col>
			<v-col col="12" id="feepay"  v-else>
        <!--1 사용자가 개인일때-->
        <user ref="user" ></user>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import user from '@/views/feepay/components/user'
import company from '@/views/feepay/components/company'

export default {
  name: 'feepay',
  components: {
    user,
    company
  },
  filters: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
    this.track()
  },
  methods: {
    track () {
      this.$gtag.pageview({
        page_path: '/feePay'
      })
    },
		getOrgname() {
      return this.$store.state.user.orgname
    },
  }
}
</script>
<style scoped>
</style>
